module.exports = __webpack_public_path__ + "img/banner1.cb03b1a0.png";